import { EconomicsScenario, Id } from "PFTypes";

import api from "../../api";

export const cloneActivityEconomicsScenario = (scenarioId: Id) =>
  api<EconomicsScenario>({
    url: `scenarios/${scenarioId}/clone`,
    method: "POST"
  });
